// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { MdAdd, MdPersonAdd } from 'react-icons/lib/md';
import i18n from 'i18n-js';

import CreateUserInBulkPopup from '../CreateUserInBulkPopup';
import * as userAction from '../../actions/users';
import CardHeader from '../CardHeader';
import CardHeaderTitleContainer from '../CardHeaderTitleContainer';
import CardHeaderTitle from '../CardHeaderTitle';
import CardHeaderIcon from '../CardHeaderIcon';
import CardHeaderLeftGroup from '../CardHeaderLeftGroup';
import CardHeaderRightGroup from '../CardHeaderRightGroup';

import styles from './usersHeader.css';
import OpenButton from '../OpenButton';
import Popup from '../Popup';
import CreateUserPopupContent from '../CreateUserPopupContent';
import { CreateButton } from '../CommonTexts';


type UsersHeaderPropTypes = {
  clearAddingError: Function,
};

const UsersHeader = ({
  clearAddingError,
}: UsersHeaderPropTypes) => (
  <Fragment>
    <CardHeader size="big">
      <CardHeaderLeftGroup>
        <CardHeaderIcon Icon={MdPersonAdd} />
        <CardHeaderTitleContainer>
          <CardHeaderTitle title={i18n.t('common.user', { count: 2 })} />
        </CardHeaderTitleContainer>
        <OpenButton
          Icon={MdAdd}
          clearBottomMargin
          id="createSingleUser"
          onClick={clearAddingError}
          title={CreateButton(i18n.t('common.user', { count: 1 }))}
          style={{ marginRight: '2rem' }}
        />
      </CardHeaderLeftGroup>
      <CardHeaderRightGroup>
        <CreateUserInBulkPopup />
      </CardHeaderRightGroup>
    </CardHeader>

    <Popup
      id="createSingleUser"
      theme="main"
      transitionMs={600}
      hideScroll
    >
      <CreateUserPopupContent />
    </Popup>
  </Fragment>
);

export default connect(
  undefined,
  dispatch => ({
    clearAddingError() {
      dispatch(userAction.clearAddUserError());
    },
  }),
)(UsersHeader);



// WEBPACK FOOTER //
// ./src/scripts/components/UsersHeader/index.jsx